import { Injectable } from '@angular/core';
import { Store, select, Action } from '@ngrx/store';
import * as fromProduct from './product.reducer';
import * as ProductSelectors from './product.selectors';
import * as ProductActions from './product.actions';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductFacade {
  loading$ = this.store.pipe(select(ProductSelectors.selectLoading));
  loadingCategories$ = this.store.pipe(
    select(ProductSelectors.selectLoadingCategories)
  );
  categories$ = this.store.pipe(select(ProductSelectors.selectCategories));
  products$ = this.store.pipe(select(ProductSelectors.selectProducts));
  selectedProduct$ = this.store.pipe(
    select(ProductSelectors.selectSelectedProduct)
  );
  error$ = this.store.pipe(select(ProductSelectors.selectError));
  variants$ = this.store.pipe(select(ProductSelectors.selectVariants));
  loadingVariants$ = this.store.pipe(
    select(ProductSelectors.selectLoadingVariants)
  );
  variantsError$ = this.store.pipe(
    select(ProductSelectors.selectVariantsError)
  );

  constructor(private store: Store<fromProduct.ProductPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadProducts(category?: string) {
    this.dispatch(ProductActions.loadProducts({ category }));
  }

  loadCategories() {
    this.dispatch(ProductActions.loadCategories());
  }

  getProductV2(id: string) {
    this.dispatch(ProductActions.getProductV2({ id }));
  }

  loadProductVariants(productId: string) {
    this.dispatch(ProductActions.loadProductVariants({ productId }));
  }
}
